import { cn } from '@bridebook/aura';
import { HTMLAttributes, LabelHTMLAttributes } from 'react';

export const Label = ({ children, className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) => (
  <label className={cn('text-base leading-[120%] font-semibold text-space', className)} {...props}>
    {children}
  </label>
);

interface ICharacterCounterProps extends HTMLAttributes<HTMLDivElement> {
  error?: boolean;
}

export const CharacterCounter = ({
  children,
  className,
  error,
  ...props
}: ICharacterCounterProps) => (
  <div
    className={cn(
      'text-right text-xs font-semibold text-space-60',
      error && 'text-alerts',
      className,
    )}
    {...props}>
    {children}
  </div>
);
